import 'lightbox2';

document.addEventListener('DOMContentLoaded', function () {

     document.querySelectorAll('.wp-block-gallery .wp-block-image img').forEach(img => {
        if (!img.closest('a')) {
            let link = document.createElement('a');
            link.href = img.src;
            link.setAttribute('data-lightbox', 'gallery');
            img.parentNode.insertBefore(link, img);
            link.appendChild(img);
        }
    });
});